<script setup>
import useSessionActions from '~/composables/sessions/useSessionActions';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);
const { isSaveSeatLoading } = useSessionActions(props.session);

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>Seat reservations are not open yet</h2>
        <p class="modal-copy fs-17">
            Seat reservations will open on August 20 for VIP pass holders and August 27 for General Admission pass
            holders.
            Please check back then!
        </p>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
